import React, { useState, useContext } from "react";
import Checkbox from "../../ui-components/Checkbox";
import Spinner from "../../ui-components/Spinner";
import {NotificationsContext} from "@ui-components/Notifications";
import DocumentInfoComponent from "./DocumentInfoComponent";
import { useIntl } from "react-intl";
import {EllipsisVerticalIcon} from "@heroicons/react/24/outline";
const WorksiteDocument = ({
	document,
	sectionKey,
	groupIndex,
	documentIndex,
	onDocumentSelected,
	dndDocumentProvider,
	dnd,
	backgroundColor,
}) => {
	const [loading, setLoading] = useState(false);
	const {push} = useContext(NotificationsContext);
	const intl = useIntl()
	return <div
		className={`p-4 flex flex-row gap-x-4 ${backgroundColor} border border-slate-500`}
		style={{marginTop: "-1px"}}
	>
		<div {...dndDocumentProvider.dragHandleProps} className={dnd ? "" : "invisible -mr-4"}>
			<EllipsisVerticalIcon className={`${dnd ? "h-6" : "w-0"} text-gray-600 cursor-move`} />
		</div>
		{document.onDocumentClicked ? <div className={"flex items-center w-20"}>
			<Checkbox
				checked={document.selected}
				onChange={(e) => {
					onDocumentSelected(sectionKey, groupIndex, documentIndex, e.target.checked)
				}}
			/>
		</div> : <div></div>}
		<div className={"flex-1 flex gap-x-5 items-center"}>
			{loading&&<div className={"relative w-5 h-5"}><Spinner spinnerColor={"#000000"}/></div>}
			<h3
				className={`text-base font-semibold text-black-500 md:whitespace-nowrap 
				flex gap-4 items-center ${document.onDocumentClicked ? "underline cursor-pointer" : ""}`}
			>
				<span onClick={async () => {
					if (document.onDocumentClicked === null)
						return
					setLoading(true)
					try {
						await document.onDocumentClicked()
					} catch (e) {
						push({type: 'error', title: intl.formatMessage({id: 'server_error'})});
					}
					setLoading(false)
				}}>
					{document.name}
				</span>
			</h3>
		</div>
		<div className={"flex items-center md:col-span-4"}>
			{document.info && <DocumentInfoComponent documentInfoPromise={document.info}/>}
		</div>
	</div>
}

export default WorksiteDocument;